import { Controller } from "stimulus";
// import request from "../../assets/request";
// import navigationHelper from "../../assets/navigation-helper";

export default class extends Controller {
    static targets = ["rating_type", "price", "price_per_ad", "price_upcoming", "price_upcoming_container", "price_upcoming_test_container"];

    connect(){
        this.rating_typeTarget.addEventListener("change", () => this.onChangeRatingType());
        this.onChangeRatingType();
    }

    onChangeRatingType() {
        const rating_type = this.rating_typeTarget.value;
        if (this.hasPriceTarget) {
            const data_key = rating_type.toLowerCase() + "Price";
            const data_key_tax = rating_type.toLowerCase() + "PriceTax";
            const price_string = '<span class="font-bold text-xl">' + this.rating_typeTarget.dataset[data_key] + '</span> ' + this.rating_typeTarget.dataset[data_key_tax];
            this.priceTarget.innerHTML = price_string;
        }
        if (this.hasPrice_per_adTarget) {
            const data_key_per_ad = rating_type.toLowerCase() + "Price_per_ad";
            const price_per_ad_string = this.rating_typeTarget.dataset[data_key_per_ad];
            this.price_per_adTarget.innerHTML = price_per_ad_string;
        }
        if (this.hasPrice_upcomingTarget) {
            const data_key_upcoming = rating_type.toLowerCase() + "Price_upcoming";
            const price_upcoming_string = this.rating_typeTarget.dataset[data_key_upcoming] || false;

            if (price_upcoming_string) {
                this.price_upcomingTarget.innerHTML = '<span class="font-bold text-xl line-through">' + price_upcoming_string + '</span> ';
                if(this.hasPrice_upcoming_containerTarget){
                  this.price_upcoming_containerTarget.style.display = "block";
                }
            } else {
              if(this.hasPrice_upcoming_containerTarget){
                this.price_upcoming_containerTarget.style.display = "none";
              }
              if(this.hasPrice_upcoming_test_containerTarget){
                this.price_upcoming_test_containerTarget.style.display = "none";
              }
            }
        }
    }
}
